import { gql } from '@apollo/client';

export default gql`
  query listPorts {
    listPorts {
      name
      code
      owner
      timeZone
    }
    selectedPort @client
  }
`;
